import createCache from "@emotion/cache";

export const emotionCache = createCache({
	key: "css",
	// This is necessary to make the emotion css always in top in CSS order
	// Most importantly, on top of the bootstrap css
	prepend: false,
});
